<template>
  <span>
    <a-time-picker
        :allowClear="allowClear"
        :disabled="disabled"
        :format="format"
        :locale="locale"
        :style="{display: block ? 'block' : 'initial'}"
        :value="momentValue"
        :disabledHours="disabledHours"
        :disabledMinutes="disabledMinutes"
        :hide-disabled-options="true"
        @change="onChange"
        @input="updateValue($event.target.value)"
    />
    <input v-if="name !== null" type="hidden" :name="name" :value="value"/>
  </span>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import moment from 'moment';
import 'moment/locale/nl';
import DateFormatEnum from "~/enums/DateFormatEnum";

export default {
  props: {
    value: {
      required: true,
    },
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: DateFormatEnum.TIME
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    disabledHours: {
      type: Function,
      default: () => {
      }
    },
    disabledMinutes: {
      type: Function,
      default: () => {
      }
    }
  },
  name: "TimePickerComponent",
  data() {
    return {
      locale,
      moment,
    };
  },
  computed: {
    momentValue() {
      let value = moment(this.value, DateFormatEnum.ISO8601);

      if (value.isValid()) return value;

      return null;
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
    onChange(value) {
      if (moment.isMoment(value)) {
        this.$emit('change', value);
        this.$emit('input', value.format(DateFormatEnum.ISO8601))
      } else {
        this.$emit('change', value);
        this.$emit('input', value)
      }
    }
  },
}
</script>

<style scoped>

</style>

<!-- TODO check if this style shouldn't be scoped ??? -->
<style>
.ant-calendar-header .ant-calendar-prev-century-btn::before,
.ant-calendar-header .ant-calendar-prev-decade-btn::before,
.ant-calendar-header .ant-calendar-prev-year-btn::before,
.ant-calendar-header .ant-calendar-prev-century-btn::after,
.ant-calendar-header .ant-calendar-prev-decade-btn::after,
.ant-calendar-header .ant-calendar-prev-year-btn::after,
.ant-calendar-header .ant-calendar-prev-year-btn::after,
.ant-calendar-header .ant-calendar-prev-month-btn::before,
.ant-calendar-header .ant-calendar-prev-month-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn::after,
.ant-calendar-header .ant-calendar-next-century-btn::before,
.ant-calendar-header .ant-calendar-next-decade-btn::before,
.ant-calendar-header .ant-calendar-next-year-btn::before,
.ant-calendar-header .ant-calendar-next-century-btn::after,
.ant-calendar-header .ant-calendar-next-decade-btn::after,
.ant-calendar-header .ant-calendar-next-year-btn::after,
.ant-calendar-header .ant-calendar-next-month-btn::before,
.ant-calendar-header .ant-calendar-next-month-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::before,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn::after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::before,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn::after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn::after {
  top: 15px;
}
</style>
